import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/client';

// Landing page for the DigiLocker redirect: ?state=...&code=...
const KycAadhaarCallback = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;           // StrictMode double-effect must not replay the single-use state
    sent.current = true;
    api.post('/api/kyc/aadhaar/callback/', { state: params.get('state'), code: params.get('code') })
      .then(() => navigate('/kyc', { replace: true }))
      .catch((e) => setError(e.response?.data?.detail || 'Aadhaar verification failed.'));
  }, [params, navigate]);

  return (
    <main style={{ padding: '4rem 1rem', textAlign: 'center' }}>
      {error ? (<><p role="alert">{error}</p><a href="/kyc">Back to KYC</a></>) : <p>Completing verification…</p>}
    </main>
  );
};

export default KycAadhaarCallback;
